<template>
	<FormKitBuilderContainer
		:vm="state.personalInfoBaseVM"
		:submit-handler="onSubmit"
		:form-errors="state.formErrors"
		scroll-to-block="center"
		class="c-health-check-tool__slide--results"
	>
		<DsButtonGroup
			mobileAlignment="start"
			mobile-direction="row"
			class="c-health-check-tool__slide-actions"
		>
			<DsIconButton
				:aria-label="labels.prev"
				icon-name="navigate-back"
				:clickHandler="onPrev"
				data-testid="prev-btn"
			></DsIconButton>
			<DsButton
				variant="primary"
				icon-end="navigate-forward"
				type="submit"
				data-testid="submit-btn"
			>
				{{ labels.submit }}
			</DsButton>
		</DsButtonGroup>
	</FormKitBuilderContainer>
	<Teleport to="[data-teleport-references]">
		<slot name="references"></slot>
	</Teleport>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import {
	DsButton,
	DsIconButton,
	DsButtonGroup,
} from '@coloplast/design-system';
import FormKitBuilderContainer from 'shared/components/FormKitBuilderContainer/FormKitBuilderContainer.vue';
import { useHealthCheckState } from '../useHealthCheckState';
import {
	track_opt_in_page_view,
	track_opt_in_page_submit,
} from 'shared/services/tracking/healthCheckTrackingService';

interface FormEvent {
	formId: string;
	formLanguage: string;
	formHostedPage: string;
	[key: string]: string;
}

interface Props {
	labels: {
		prev: string;
		submit: string;
	};
}

const { state } = useHealthCheckState();

defineProps<Props>();

const emit = defineEmits(['prev', 'submit']);

onMounted(() => {
	track_opt_in_page_view();
});

function onSubmit(formData: FormEvent) {
	track_opt_in_page_submit();
	emit('submit', formData);
}
function onPrev() {
	emit('prev');
}
</script>

<style scoped lang="scss">
@import 'multisite/styles/settings/settings';
@import 'multisite/styles/tools/tools';

.c-health-check-tool__slide {
	--formkit-form--margin-block-start: ds-space(13);

	&--results {
		:deep(form.formkit-form) {
			> div.formkit-outer[data-type='checkbox'] {
				margin-top: ds-space(6);

				.formkit-messages {
					margin-inline-start: ds-space(9);
					padding-inline-start: ds-space(2);
				}
			}
		}

		:deep(.formkit-message) {
			font-size: t-rem(14px);
		}
	}

	&-actions {
		align-items: center;
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		margin-block-start: ds-space(5);
		width: 100%;
	}
}
</style>
